export default "6,Tidlig høstland\n5,Parringsland\n"